import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { AddLessonStore, Lesson } from "./add-lession/addLesson";
import { AddSurveyStore, Survey } from "./add-survey/addSurvey";
import { AuthState, AuthTokenSlice } from "./auth/slice";
import {
  AutomaticScoreSlice,
  createAutomaticScoreSlice,
} from "./automatic-scoring/slices";
import { colorSettingSlice, ColorState } from "./color-setting/color";
import {
  courseConstructionSlice,
  CourseConstructionState,
} from "./course-construction/slice";
import {
  courseManagementSlice,
  CourseManagementState,
} from "./course-management/slice";
import {
  CourseStrutureSlice,
  createCourseStrutureSlice,
} from "./course-plan-managment/detail-course-plan/slice";
import { coursesSlice } from "./courses/slice";
import { curriculumSlice } from "./curriculum/slice";
import { globalSlice } from "./global/global";
import { headerSlice } from "./header";
import {
  learningMaterialSlice,
  LearningMaterialState,
} from "./learning-material/slice";
import {
  AccountMinistrySlice,
  createMinistryTeachersSlice,
} from "./list-account-ministry/slice";
import {
  AccountTeacherSlice,
  createAccountTeachersSlice,
} from "./list-account-teachers/slices";
import {
  AccountUserSlice,
  createAccountUserSlice,
} from "./list-account-users/slices";
import { IRolesSlice, rolesSlices } from "./list-roles/slices";
import { notificationSlice, NotificationState } from "./notification/slice";
import { AddPermissionStore, Permission } from "./permission/slice";
import { Sider, SiderStore } from "./sider/sider";
import { staticReportSlice, StaticReportState } from "./static-report/slice";
import {
  createStudyManagementSlice,
  StudyManagementSlice,
} from "./study-management/slices";
import {
  createSurveyDetailSlice,
  createSurveyInfoSlice,
  SurveyDetailSlice,
  SurveyInfoSlice,
} from "./survey-managment/detail-survey/slice";
import {
  createSurveyRespondSlice,
  SurveyRespondSlice,
} from "./survey-managment/mooc-survey-respond/slice";
import {
  ThemeSurvey,
  ThemeSurveyStore,
} from "./survey-managment/survey-theme/store-theme";
import { createFilterSlice, FilterState } from "./learning-repository/slice";

export const useAppStore = create<
  AccountUserSlice & AccountTeacherSlice & AccountMinistrySlice
>()(
  devtools(
    (...a) => ({
      ...createAccountUserSlice(...a),
      ...createAccountTeachersSlice(...a),
      ...createMinistryTeachersSlice(...a),
    }),
    {
      name: "list-account",
    }
  )
);

export const useRolesStore = create<IRolesSlice>()(
  devtools<IRolesSlice>(
    (...b) => ({
      ...rolesSlices(...b),
    }),
    {
      name: "list-roles",
    }
  )
);

export const useStudyManagementStore = create<StudyManagementSlice>()(
  devtools<StudyManagementSlice>(
    (...b) => ({
      ...createStudyManagementSlice(...b),
    }),
    {
      name: "study-management",
    }
  )
);

export const useAuthStore = create<AuthState>()(
  devtools(
    persist<AuthState>(
      (...a) => ({
        ...AuthTokenSlice(...a),
      }),
      { name: "auth-storage" }
    ),
    { name: "auth" }
  )
);

export const useSider = create<Sider>()(
  devtools(
    persist<Sider>(
      (...a) => ({
        ...SiderStore(...a),
      }),
      { name: "sider-storage" }
    ),
    { name: "auth" }
  )
);

export const useAddLesson = create<Lesson>()(
  devtools(
    persist<Lesson>(
      (...a) => ({
        ...AddLessonStore(...a),
      }),
      { name: "add-lesson-storage" }
    )
  )
);

export const useSurveyDetail = create<SurveyDetailSlice>()(
  devtools(
    persist(
      (...a) => ({
        ...createSurveyDetailSlice(...a),
      }),
      { name: "listSurveySection-storage" }
    ),
    { name: "listSurveySection" }
  )
);

export const useSurveyInfo = create<SurveyInfoSlice>()(
  devtools(
    persist(
      (...a) => ({
        ...createSurveyInfoSlice(...a),
      }),
      { name: "surveyInfo-storage" }
    ),
    { name: "surveyInfo" }
  )
);

export const useSurveyRespond = create<SurveyRespondSlice>()(
  devtools(
    persist(
      (...a) => ({
        ...createSurveyRespondSlice(...a),
      }),
      { name: "surveyRespond-storage" }
    ),
    { name: "surveyRespond" }
  )
);

export const useAutomaticScoreStore = create<AutomaticScoreSlice>()(
  devtools<AutomaticScoreSlice>(
    (...b) => ({
      ...createAutomaticScoreSlice(...b),
    }),
    {
      name: "auto-score",
    }
  )
);
export const useAddSurvey = create<Survey>()(
  devtools(
    persist<Survey>(
      (...a) => ({
        ...AddSurveyStore(...a),
      }),
      { name: "add-survey-storage" }
    )
  )
);

export const useAddPermission = create<Permission>()(
  devtools(
    persist<Permission>(
      (...a) => ({
        ...AddPermissionStore(...a),
      }),
      { name: "permission-storage" }
    )
  )
);

export const useThemeSurvey = create<ThemeSurvey>()(
  devtools(
    persist<ThemeSurvey>(
      (...a) => ({
        ...ThemeSurveyStore(...a),
      }),
      { name: "Theme-survey-storage" }
    ),
    { name: "auth" }
  )
);

export const useCourseStructure = create<CourseStrutureSlice>()(
  devtools(
    persist(
      (...a) => ({
        ...createCourseStrutureSlice(...a),
      }),
      { name: "courseStructure-storage" }
    ),
    { name: "courseStructure" }
  )
);

export const useCoursesStore = create<any>()(
  devtools<any>(
    (...b) => ({
      ...coursesSlice(...b),
    }),
    {
      name: "courses",
    }
  )
);

export const globalStore = create<any>()(
  devtools<any>(
    (...b) => ({
      ...globalSlice(...b),
    }),
    {
      name: "global",
    }
  )
);

export const useCurriculumStore = create<any>()(
  devtools<any>(
    (...b) => ({
      ...curriculumSlice(...b),
    }),
    {
      name: "curriculum",
    }
  )
);

export const headerStore = create<any>()(
  devtools<any>(
    (...b) => ({
      ...headerSlice(...b),
    }),
    {
      name: "header",
    }
  )
);

export const useNotificationStore = create<NotificationState>()(
  devtools<NotificationState>(
    (...b) => ({
      ...notificationSlice(...b),
    }),
    {
      name: "notification",
    }
  )
);

export const colorStore = create<ColorState>()(
  devtools<ColorState>(
    (...b) => ({
      ...colorSettingSlice(...b),
    }),
    {
      name: "color-setting",
    }
  )
);

export const staticReportStore = create<StaticReportState>()(
  devtools<StaticReportState>(
    (...b) => ({
      ...staticReportSlice(...b),
    }),
    {
      name: "static-report",
    }
  )
);

export const LearningMaterialStore = create<LearningMaterialState>()(
  devtools<LearningMaterialState>(
    (...b) => ({
      ...learningMaterialSlice(...b),
    }),
    {
      name: "static-report",
    }
  )
);

export const CourseManagementStore = create<CourseManagementState>()(
  devtools<CourseManagementState>(
    (...b) => ({
      ...courseManagementSlice(...b),
    }),
    {
      name: "course-management",
    }
  )
);

export const CourseConstructionStore = create<CourseConstructionState>()(
  devtools<CourseConstructionState>(
    (...b) => ({
      ...courseConstructionSlice(...b),
    }),
    {
      name: "course-management",
    }
  )
);
export const useLearningRepositoryStore = create<FilterState>()(
  devtools(
    (...a) => ({
      ...createFilterSlice(...a),
    }),
    { name: "filter-learning-repository" }
  )
);
